import PlayCircle from './PlayCircle'
import PauseCircle from './PauseCircle'

const VideoPlaceholder = ({ image, handleVideoPlay, videoIsActive }) => {
    // console.log('image in Video Placeholder', image)
    return (
        <div className="video-placeholder-outer" onClick={handleVideoPlay}>
            <div
                className="video-placeholder-inner"
                title={videoIsActive ? 'Pause Video' : 'Play Video'}
            >
                <img
                    src={image && image.src ? image.src : image.imageSrc}
                    alt={image && image.alt ? image.alt : image.imageAlt}
                />
                {videoIsActive ? <PauseCircle /> : <PlayCircle />}
            </div>
        </div>
    )
}

export default VideoPlaceholder
